var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plankton-cell table-cell",attrs:{"span":_vm.hSpan}},[_c('div',{staticClass:"inner-grid"},[_c('div',{class:("cell-content cell-content--span-" + _vm.vSpan)},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }